var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.4436,
    width: 9.37838,
    height: 9.66667,
    rx: 4.68919,
    stroke: "#ABABAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.623,
    y: 14.7769,
    width: 9.37838,
    height: 9.66667,
    rx: 4.68919,
    stroke: "#ABABAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9746,
    y: 1.4436,
    width: 9.37838,
    height: 9.66667,
    rx: 2.5,
    stroke: "#ABABAB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.64844,
    y: 14.7769,
    width: 9.37838,
    height: 9.66667,
    rx: 2.5,
    stroke: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.f3fb24af3c32ae959a4af2fcf7201265.svg";
export { ForwardRef as ReactComponent };